"use client";

import { useState, useEffect } from "react";
import { useParams } from "next/navigation";
import { useTranslations } from "next-intl";
import TFLink from "@/Web/Components/TFLink/TFLink";
import TFLayoutHomeSection from "@/Web/Components/TFLayoutHomeSection/TFLayoutHomeSection";
import apiCall from "@/libs/api";

export default function SectionFAQ() {
  const t = useTranslations("web.pages.home.sections.faq");
  const params = useParams<{ locale: string }>();
  const locale = params?.locale || "en";
  const [faqItems, setFaqItems] = useState<APIDataHubFaq[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadFAQ = async () => {
      try {
        setIsLoading(true);
        const response = await apiCall("hub/faq/list", {
          locale: locale as UILocale,
        });
        setFaqItems(response.faq.slice(0, 12));
      } catch (error) {
        console.error("Failed to load FAQ:", error);
      } finally {
        setIsLoading(false);
      }
    };

    loadFAQ();
  }, [locale]);

  if (isLoading || faqItems.length === 0) {
    return null;
  }

  return (
    <TFLayoutHomeSection
      title={t("title")}
      // description="Находите ответы на популярные вопросы о платформе Tiferet"
      moreButton={{
        title: t("allQuestions"),
        href: "/help/faq",
      }}
    >
      {/* Masonry layout */}
      <div className="columns-1 md:columns-2 lg:columns-3 gap-3">
        {faqItems.map((item) => (
          <div key={item.ref} className="break-inside-avoid mb-3">
            <TFLink
              href={`/help/faq/${item.ref}`}
              className="bg-black/5 rounded-lg p-4 hover:bg-black/10 transition-colors h-full flex flex-col group"
            >
              <h3 className="text-base font-semibold text-black group-hover:text-black/70 transition-colors">
                {item.question}
              </h3>
            </TFLink>
          </div>
        ))}
      </div>
    </TFLayoutHomeSection>
  );
}
